'use client'
import { useState } from 'react'
import { createContainer } from 'unstated-next'

/** Manage the shared state across a given Favorites tile. */
function useFavoritesTileImpl() {
  // Whether or not the current tile is pending removal (i.e. "favorites heart" was clicked)
  const [isPendingRemoval, setIsPendingRemoval] = useState(false)
  return { isPendingRemoval, setIsPendingRemoval }
}

const FavoritesTileContainer = createContainer(useFavoritesTileImpl)
export const FavoritesTileProvider = FavoritesTileContainer.Provider

export const useFavoritesTile = FavoritesTileContainer.useContainer
